import { Coffee, Gym, Pool, Wifi } from '@v2/ui';
import { Car02 } from '@v2/ui/Icon/MapsAndTravel';

export const STAR_RATINGS_LIST = [1, 2, 3, 4, 5];
export const HOTEL_FEATURES_LIST = [
  {
    label: 'WiFi',
    value: 'WiFi',
    icon: <Wifi size="16" />,
  },
  {
    label: 'Parking',
    value: 'Parking',
    icon: <Car02 size="16" />,
  },
  {
    label: 'Breakfast',
    value: 'Breakfast',
    icon: <Coffee viewBox="0 0 16 16" size="16" />,
  },
  {
    label: 'Pool',
    value: 'Pool',
    icon: <Pool viewBox="0 0 16 16" size="16" />,
  },
  {
    label: 'Fitness',
    value: 'Fitness',
    icon: <Gym viewBox="0 0 16 16" size="16" />,
  },
];

export const HOTEL_AMENETIES = [
  {
    label: 'WiFi',
    value: 'WiFi',
    icon: <Wifi size="16" className="text-gray-500" />,
  },
  {
    label: 'Parking',
    value: 'Parking',
    icon: <Car02 size="16" className="text-gray-500" />,
  },
  {
    label: 'Breakfast',
    value: 'Breakfast',
    icon: <Coffee viewBox="0 0 16 16" size="16" className="text-gray-500" />,
  },
  {
    label: 'Pool',
    value: 'Pool',
    icon: <Pool viewBox="0 0 16 16" size="16" className="text-gray-500" />,
  },
  {
    label: 'Fitness',
    value: 'Fitness',
    icon: <Gym viewBox="0 0 16 16" size="16" className="text-gray-500" />,
  },
];

export const HOTEL_SORT_OPTIONS = [
  { name: 'Recommended', value: 'recommended' },
  { name: 'Distance to search location', value: 'distance-low-high' },
  { name: 'Price: low to high', value: 'price-low-high' },
  { name: 'Price: high to low', value: 'price-high-low' },
  { name: 'Stars: low to high', value: 'rating-low-high' },
  { name: 'Stars: high to low', value: 'rating-high-low' },
];
